import { useEditor, EditorContent } from '@tiptap/react'
import StarterKit from '@tiptap/starter-kit'
import { FaBold, FaItalic, FaListUl, FaHeading } from 'react-icons/fa'

const MenuBar = ({ editor }) => {
  if (!editor) {
    return null
  }

  return (
    <div className="border-b border-gray-200 pb-2 mb-2 flex flex-wrap gap-1">
      <button
        type="button"
        onClick={() => editor.chain().focus().toggleHeading({ level: 1 }).run()}
        className={`flex p-2 items-center gap-0.5 rounded hover:bg-gray-100 ${editor.isActive('heading', { level: 1 }) ? 'bg-gray-200 dark:text-gray-700' : ''}`}
        title="Heading 1"
      >
        <FaHeading className="w-4 h-4" />
        <span className="text-md">1</span>
      </button>
      <button
        type="button"
        onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}
        className={`flex p-2 items-center gap-0.5 rounded hover:bg-gray-100 ${editor.isActive('heading', { level: 2 }) ? 'bg-gray-200 dark:text-gray-700' : ''}`}
        title="Heading 2"
      >
        <FaHeading className="w-4 h-4" />
        <span className="text-md">2</span>
      </button>
      <button
        type="button"
        onClick={() => editor.chain().focus().toggleHeading({ level: 3 }).run()}
        className={`flex p-2 items-center gap-0.5 rounded hover:bg-gray-100 ${editor.isActive('heading', { level: 3 }) ? 'bg-gray-200 dark:text-gray-700' : ''}`}
        title="Heading 3"
      >
        <FaHeading className="w-4 h-4" />
        <span className="text-md">3</span>
      </button>
      <button
        type="button"
        onClick={() => editor.chain().focus().toggleBold().run()}
        className={`p-2 rounded hover:bg-gray-100 ${editor.isActive('bold') ? 'bg-gray-200 dark:text-gray-700' : ''}`}
        title="Bold"
      >
        <FaBold className="w-4 h-4" />
      </button>
      <button
        type="button"
        onClick={() => editor.chain().focus().toggleItalic().run()}
        className={`p-2 rounded hover:bg-gray-100 ${editor.isActive('italic') ? 'bg-gray-200 dark:text-gray-700' : ''}`}
        title="Italic"
      >
        <FaItalic className="w-4 h-4" />
      </button>
      <button
        type="button"
        onClick={() => editor.chain().focus().toggleBulletList().run()}
        className={`p-2 rounded hover:bg-gray-100 ${editor.isActive('bulletList') ? 'bg-gray-200 dark:text-gray-700' : ''}`}
        title="Bullet List"
      >
        <FaListUl className="w-4 h-4" />
      </button>
    </div>
  )
}

const RichTextEditor = ({ content, onChange }) => {
  const editor = useEditor({
    extensions: [
      StarterKit,
    ],
    content: content,
    onUpdate: ({ editor }) => {
      onChange(editor.getHTML());
    },
  })

  return (
    <div className="border border-gray-300 rounded-lg p-2 min-h-[200px]">
      <MenuBar editor={editor} />
      <EditorContent 
        editor={editor} 
        className="prose max-w-none min-h-[150px] text-gray-700 dark:text-gray-100 h-60 overflow-y-auto" 
      />
    </div>
  )
}

export default RichTextEditor; 